import Vue from 'vue'
import VueRouter from 'vue-router'

import ViewLogin from 'Views/ViewLogin'
import ViewCalendar from 'Views/ViewCalendar'
import ViewPatientAdd from 'Views/ViewPatientAdd'
import ViewPatientShow from 'Views/ViewPatientShow'
import ViewPatientEdit from 'Views/ViewPatientEdit'
import ViewPatientVisits from 'Views/ViewPatientVisits'
import ViewPatientEventAdd from 'Views/ViewPatientEventAdd'
import ViewPatientEventEdit from 'Views/ViewPatientEventEdit'
import ViewPatientVisitEdit from 'Views/ViewPatientVisitEdit'
import ViewPatients from 'Views/ViewPatients'
import ViewSettings from 'Views/ViewSettings'
import ViewLogout from 'Views/ViewLogout'
import ViewResetPassword from 'Views/ViewResetPassword'
import ViewNewPassword from 'Views/ViewNewPassword'
import View404 from 'Views/View404'


Vue.use(VueRouter)

let router = new VueRouter({
    mode: 'history',
    routes: [
        {
            path: '',
            redirect: {
                name: 'Calendar'
            }
        },
        {
            path: '/kalendarz',
            name: 'Calendar',
            component: ViewCalendar,
            meta: {
                auth: true
            }
        },
        {
            path: '/pacjenci/dodaj',
            name: 'PatientAdd',
            component: ViewPatientAdd,
            meta: {
                auth: true
            },
        },
        {
            path: '/pacjenci/:id',
            name: 'PatientShow',
            component: ViewPatientShow,
            meta: {
                auth: true
            },
        },
        {
            path: '/pacjenci/:id/edytuj',
            name: 'PatientEdit',
            component: ViewPatientEdit,
            meta: {
                auth: true
            },
        },
        {
            path: '/pacjenci/:id/wizyty',
            name: 'PatientVisits',
            component: ViewPatientVisits,
            meta: {
                auth: true
            },
        },
        {
            path: '/pacjenci/:id/planowana-wizyta/dodaj',
            name: 'PatientEventAdd',
            component: ViewPatientEventAdd,
            meta: {
                auth: true
            },
        },
        {
            path: '/pacjenci/:id/planowana-wizyta/:eventId/edytuj',
            name: 'PatientEventEdit',
            component: ViewPatientEventEdit,
            meta: {
                auth: true
            },
        },
        {
            path: '/pacjenci/:id/wizyta/:id1/przebieg',
            name: 'PatientVisitEdit',
            component: ViewPatientVisitEdit,
            meta: {
                auth: true
            },
        },
        {
            path: '/pacjenci',
            name: 'Patients',
            component: ViewPatients,
            meta: {
                auth: true
            },
        },
        {
            path: '/ustawienia',
            name: 'Settings',
            component: ViewSettings,
            meta: {
                auth: true
            }
        },
        {
            path: '/wyloguj',
            name: 'Logout',
            component: ViewLogout,
            meta: {
                auth: true,
                layout: 'public'
            }
        },
        {
            path: '/zaloguj/:loginToken?',
            name: 'Login',
            component: ViewLogin,
            meta: {
                // auth: false,
                layout: 'public'
            },
            props: true
        },
        {
            path: '/reset-hasla',
            name: 'ResetPassword',
            component: ViewResetPassword,
            meta: {
                auth: false,
                layout: 'public'
            }
        },
        {
            path: '/nowe-haslo',
            name: 'NewPassword',
            component: ViewNewPassword,
            meta: {
                auth: false,
                layout: 'public'
            }
        },
        {
            path: '*',
            name: '404',
            component: View404,
            meta: {
                layout: 'public'
            }
        }
    ]
})

export default router
